import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import NoData from "@/components/NoData";
import Button from "@/components/buttons/Button";
import MySubscriptionCard from "@/components/cards/SubscriptionCard/MySubscriptionCard.tsx";
import BackButton from "@/components/staff/BackButton.tsx";

import { ROUTES } from "@/config/routes";
import { useGetSubscriptions, useGetUser } from "@/hooks/api/user.hooks";
import { filterAndMergeSubscriptions } from "@/utils/subscription";

const StaffSubscriptionPage = (): JSX.Element => {
  const { t } = useTranslation();

  const { data: subs } = useGetSubscriptions();
  const { data: user } = useGetUser();

  const userSubs = user.subscriptions;

  const mergedSubs = filterAndMergeSubscriptions(subs, userSubs);
  const navigate = useNavigate();

  return (
    <>
      <BackButton />
      <h1 className={"text-[2rem]/10 font-semibold max-lg:mt-6"}>{t("Subscription.my-subs")}</h1>
      {mergedSubs.length ? (
        <section
          className={
            "mt-8 grid grid-cols-3 gap-6 max-2xl:grid-cols-2 max-xl:grid-cols-1 max-lg:mt-6 max-lg:grid-cols-2 max-md:grid-cols-1"
          }
        >
          {mergedSubs.map((subscription) => (
            <MySubscriptionCard key={subscription.id} {...subscription} />
          ))}
        </section>
      ) : (
        <div>
          <NoData message={t("NoData.subs")}>
            <Button onClick={() => navigate(ROUTES.SUBS)} className="w-max">
              {t("buy-subs")}
            </Button>
          </NoData>
        </div>
      )}
    </>
  );
};

export default StaffSubscriptionPage;
